export default __webpack_public_path__ + "static/media/Think5WhysCertTemplateAug24.81acfcfd4c817efbffa74ee196182951.png";